
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { User } from "lucide-react";
import { Profile } from "@/services/profiles/types";

// Create a simpler interface for the profile data that comes from the swap request
interface SwapRequestProfile {
  username: string | null;
  lab: string | null;
  university: string | null;
}

interface RequesterInfoCardProps {
  profile?: SwapRequestProfile | Profile;
}

const RequesterInfoCard: React.FC<RequesterInfoCardProps> = ({ profile }) => {
  return (
    <div>
      <h3 className="text-lg font-medium mb-3 flex items-center">
        <User className="h-5 w-5 mr-2 text-reagent-blue" />
        Requested By
      </h3>
      <Card>
        <CardContent className="pt-6">
          <div className="space-y-3">
            <div>
              <p className="text-sm text-muted-foreground">Researcher</p>
              <p className="font-medium">{profile?.username || "Unknown"}</p>
            </div>
            
            {profile?.lab && (
              <div>
                <p className="text-sm text-muted-foreground">Lab</p>
                <p>{profile.lab}</p>
              </div>
            )}
            
            {profile?.university && (
              <div>
                <p className="text-sm text-muted-foreground">Institution</p>
                <p>{profile.university}</p>
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default RequesterInfoCard;
